import axios from "axios";



// const token= `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjljZDM1ZDM2LTY0MTAtNDFkNy05MjkwLThiZjJlZTk2ZGViZiIsImVtYWlsIjoiYWRlZ29rZWdib2xhaGFuMjRAZ21haWwuY29tIiwicm9sZSI6ImNsaWVudCIsImlhdCI6MTc0MDEzMDExMiwiZXhwIjoxNzQwMjE2NTEyfQ.75lgJ1hBUjP5d5xG1go3OUAQeceYEnkkxocq6x1ohqU`
const instance= axios.create({
    baseURL:"https://connectifie.gamequiz.live",
   
})
instance.interceptors.request.use(config => {
    let accessToken =sessionStorage.getItem("token")
    
   
    if (accessToken) {
        config.headers["Authorization"]= `bearer ${accessToken}`
    }
    if ( !accessToken) {   
        console.log("returned config")
        return config
    }
   
    else {
        try {          
            return config 
        }
        catch (ex) {
            console.log({ex})
        }
    }

})
export default instance